import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Globals } from '@foh/globals';


@Injectable({
  providedIn: 'root'
})
export class TicketpaymentService {

  constructor(private globals : Globals,private http : HttpClient) { }

    retrieveTickets(params: {}) {
        return this.http.get(this.globals.WEBAPI + this.globals.URL_PAYMENTS_UNPAIDTICKETSLIST, {params: params});
    }

    retrievePaidTicket(params: {}) {
        return this.http.get(this.globals.WEBAPI + this.globals.URL_PAYMENTS_SINGLEPAIDTICKET, {params: params});
    }

    createTicketsGroup(params: {}) {
        return this.http.post(this.globals.WEBAPI + this.globals.URL_PAYMENTS_TICKETS_CREATEGROUP,  params);
    }

    deleteTicketsGroup(params: {}) {
        return this.http.get(this.globals.WEBAPI + this.globals.URL_PAYMENTS_TICKETS_DELETEGROUP,   {params: params});
    }

    getTicketGroup(params: {}){
      return this.http.get(this.globals.WEBAPI + this.globals.URL_PAYMENTS_TICKETS_GETGROUP, {params: params});
    }

    createPaymentLink(params: {}) {
        return this.http.post(this.globals.WEBAPI + this.globals.URL_PAYMENTS_TICKETS_CREATEPAYMENTLINK, params);
    }

    retrieveOrderStatus(params: {}){
        return this.http.post(this.globals.WEBAPI + this.globals.URL_PAYMENTS_RETRIEVETICKETSORDERSTATUS, params);
    }





}
